<script lang="ts" setup>
const props = defineProps<{
  embedCode: string
}>()

const height = ref(0)
const { initiatedThirdParty } = useApp()
const encodedEmbedCode = encode(props.embedCode)

function onMessage(event: MessageEvent) {
  if (event.data?.type === 'iframe-height') {
    height.value = event.data.height
  }
}

onMounted(() => {
  window.addEventListener('message', onMessage)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', onMessage)
})
</script>

<template>
  <iframe
    v-if="initiatedThirdParty"
    class="ui-embed-framed"
    :src="`/embed/?id=${encodedEmbedCode}`"
    :style="`height: ${height}px;`"
    loading="lazy"
  />
</template>

<style>
@import url('~layers/components/Ui/Embed.css');
</style>
